import React from 'react';
const bonuses = [{
  title: 'Puppy Success Blueprint™',
  description: 'Everything you need to work confidently with puppies — socialization, first commands, house training, and behavior problem prevention from Day One.'
}, {
  title: '50 High-Engagement Training Games™',
  description: '50 science-backed games to boost focus, motivation, and results — recall, impulse control, confidence-building, and more.'
}, {
  title: 'Canine Body Language Mastery™',
  description: 'Read stress signals, fear indicators, and calming signals accurately — and make smarter training decisions before problems escalate.'
}, {
  title: 'Professional Assessment Forms Pack™',
  description: 'Consultation forms, progress tracking templates, and client reports — ready to use immediately and professionally.'
}, {
  title: 'Dog Trainer Social Media Content Kit™',
  description: '100 post ideas, content templates, and a monthly calendar to attract new clients and build your authority online — effortlessly.'
}];
const benefits = [{
  emoji: '⚡',
  title: 'Save Hours Every Week',
  desc: 'Stop creating training sessions from scratch. Open the system, choose the protocol, and work with confidence from minute one — knowing every session is backed by science and structured for results.'
}, {
  emoji: '👑',
  title: 'Greater Professional Confidence',
  desc: 'Know exactly what to work on, how to progress every dog systematically, and how to adapt your approach safely for every reactivity type, breed, age, and temperament.'
}, {
  emoji: '🐾',
  title: 'Better Dog Results',
  desc: "Structured programs focused on counter-conditioning, impulse control, relaxation protocols, and real-world generalization — producing calm, responsive dogs whose owners can't stop talking about the change they see."
}, {
  emoji: '😊',
  title: 'Higher Client Retention & Referrals',
  desc: 'Keep owners motivated and engaged with progressive programming, professional communication tools, and visible results that turn one-time clients into long-term relationships and enthusiastic word-of-mouth referrals.'
}];
export function BonusSection() {
  return <>
      <section className="py-7 px-4 sm:px-6 bg-brand-beige" data-id="element-15">
        <div className="text-center mb-5" data-id="element-16">
          <h2 className="text-2xl sm:text-3xl font-heading font-black text-brand-green mb-2 uppercase leading-tight" data-id="element-17">
            5 PREMIUM BONUSES INCLUDED
          </h2>
          <p className="text-sm sm:text-base font-bold text-brand-brown leading-snug max-w-xl mx-auto" data-id="element-18">
            Plus, you'll receive 5 premium bonuses — exclusive resources
            designed to save even more time and deliver better results.
          </p>
        </div>

        <div className="flex flex-col gap-2.5 mb-4" data-id="element-19">
          {bonuses.map((bonus, i) => <div key={i} className="bg-white border-2 border-brand-gold/50 p-4 rounded-md text-center shadow-sm" data-id="element-20">
              <p className="text-[11px] font-bold text-brand-gold mb-1 tracking-wider uppercase" data-id="element-21">
                🎁 BONUS {i + 1}
              </p>
              <h3 className="text-sm font-bold text-brand-green mb-1 leading-tight" data-id="element-22">
                {bonus.title}
              </h3>
              <p className="text-xs text-brand-ink/80 leading-snug" data-id="element-23">
                {bonus.description}
              </p>
            </div>)}
        </div>

        <p className="text-center font-bold text-brand-green text-sm uppercase tracking-wide bg-brand-gold/20 border border-brand-gold/40 py-2.5 rounded-md" data-id="element-24">
          The 5 bonuses are FREE with your purchase today.
        </p>
      </section>

      <section className="py-7 px-4 sm:px-6 bg-white border-y-2 border-brand-brown/15" data-id="element-25">
        <h2 className="text-2xl sm:text-3xl font-heading font-black text-center text-brand-green mb-2 uppercase leading-tight" data-id="element-26">
          WHAT IS GOING TO CHANGE
        </h2>
        <p className="text-sm sm:text-base font-medium text-center text-brand-ink mb-5 leading-snug max-w-xl mx-auto" data-id="element-27">
          What will change in your professional life — real benefits starting
          from your very first week:
        </p>

        <div className="flex flex-col gap-3" data-id="element-28">
          {benefits.map((item, i) => <div key={i} className="bg-brand-beige border-l-4 border-brand-orange p-4 rounded-r-md shadow-sm flex gap-3 items-start" data-id="element-29">
              <div className="text-xl shrink-0 leading-none mt-0.5" data-id="element-30">
                {item.emoji}
              </div>
              <div data-id="element-31">
                <h3 className="text-sm font-bold text-brand-green mb-1 uppercase tracking-tight" data-id="element-32">
                  {item.title}
                </h3>
                <p className="text-brand-ink/80 text-sm leading-snug" data-id="element-33">
                  {item.desc}
                </p>
              </div>
            </div>)}
        </div>
      </section>
    </>;
}